import React from 'react';
import DeclarationReport from '../declaration-report';

class DeclarationReportModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = { }
    }

    render() {
        return (
            <div className="modal aem" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.modalId}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <DeclarationReport id={this.props.id} declarationType={this.props.declarationType} dispatch={this.props.dispatch}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

DeclarationReportModal.defaultProps = { }
export default DeclarationReportModal;